import * as React from 'react'
import styled, { css } from 'styled-components'

import Icon from '../../../../components/ui/Icon/Icon'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'

import RightSideBarHeader from '../../../../assets/img/right-sidebar-header.svg'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

import * as ProfileService from '../../../../services/api/requests/Profile'

import { MAIN } from '../../../../services/data/profilePages.json'
import { APP_NAME } from '../../../../static/constants'

const MainPage = styled.div`
  overflow: auto;
  height: 100%;

  &::before {
    content: ' ';
    display: block;
    height: 244px;
    background-color: var(--color-primary);
    background: url('${RightSideBarHeader}'), url('${MoreHeaderParticles}'), linear-gradient(var(--color-primary), var(--color-primary));
    background-position: bottom, right top;
    background-repeat: no-repeat;
    background-size: 100%, auto;
  }
`

const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  z-index: 100;

  ${props =>
    props.hasScrolled &&
    css`
    background: url('${MoreHeaderParticles}'), linear-gradient(var(--color-primary), var(--color-primary));
    background-repeat: no-repeat;
    background-position: right top;
  `}
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  overflow: auto;
`

const CodeContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`
const CodeField = styled.div.attrs({ readOnly: true })`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  color: var(--color-primary);
  font-size: 1.5rem;
  font-weight: var(--font-weight-boldest);
  letter-spacing: 1.33px;
  border: 1px solid var(--color-primary);
  border-radius: 0.3rem 0 0 0.3rem;
  text-align: center;
  height: 3.5625rem;
`

const CopyButton = styled(ActionButton)`
  font-size: 0.875rem;
  font-weight: var(--font-weight-boldest);
  letter-spacing: 0.78px;
  border-radius: 0 0.3rem 0.3rem 0;
  height: 3.5625rem;

  &:hover {
    background-color: #707070 !important;
    border-color: #707070 !important;
  }
`

const ErrorMessage = styled.p`
  color: red;
  font-size: 13px;
  margin: 0 !important;
  padding: 0 !important;
`

const HiddenInput = styled.input.attrs({ readOnly: true })`
  position: absolute;
  top: -999999%;
  left: -999999%;
`

const SubTitle = styled.h2`
  color: var(--color-primary);
  font-size: 1.25rem;
  font-weight: var(--font-weight-boldest);
  letter-spacing: 0.56px;
  margin: 0;
  margin-bottom: 1.375rem;
`

const PointsDescription = styled.p`
  color: #000;
  line-height: 1.3125rem;
  letter-spacing: 0.29px;
  text-align: center;
  margin: 0;
  margin-bottom: 2.5rem;
`

const Description = styled.p`
  font-size: 0.875rem;
  line-height: 1.3125rem;
  letter-spacing: 0.29px;
  text-align: center;
  margin: 0;
  margin-bottom: 3.5rem;
`

const ReferralLabel = styled.p`
  font-size: 0.875rem;
  line-height: 1.3125rem;
  letter-spacing: 0.13;
  margin: 0;
  margin-bottom: 0.8125rem;
`

class ReferPage extends React.Component {
  constructor(props) {
    super(props)

    const { accessToken, setReferCodeError } = this.props

    this.state = {
      referralCode: '',
    }

    this.currentPage = React.createRef()

    ProfileService.getReferralCode(accessToken)
      .then(response => {
        this.setState({ referralCode: response.data.code })
      })
      .catch(error => {
        setReferCodeError(error)
      })
  }

  componentDidMount() {
    this.currentPage.current.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    this.currentPage.current.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = event => {
    const { hasScrolled: hasScrolledState } = this.state
    const { scrollTop } = event.target
    const hasScrolled = scrollTop > 0

    if (hasScrolled !== hasScrolledState) {
      this.setState({
        hasScrolled,
      })
    }
  }

  copyCode() {
    document.getElementById('refCodeMessage').select()
    document.execCommand('copy')
  }

  render() {
    const { referralCode, hasScrolled } = this.state
    const { setProfileModalPage, referError } = this.props

    return (
      <MainPage ref={this.currentPage}>
        <Header hasScrolled={hasScrolled}>
          <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
            <Icon name="slide-left" />
          </ReturnIcon>
          <Title>Refer a Friend</Title>
        </Header>
        <Content>
          <SubTitle>Invite friends</SubTitle>
          <PointsDescription>
            Invite your friends to download {APP_NAME} and earn 5 Zing Points*
            when they register and link their GCash account.
          </PointsDescription>
          <Description>
            *Referral bonus points will be awarded to a maximum of three
            successful referrals per month.
          </Description>
          <ReferralLabel>Share your referral code:</ReferralLabel>
          {referError && <ErrorMessage>Failed to generate code</ErrorMessage>}
          <HiddenInput
            id="refCodeMessage"
            value={`Sign up to ${APP_NAME} using my referral code ${referralCode} or use this ${process.env.REACT_APP_BASE_URL}/register/referral/${referralCode} to earn points and discover a world of exclusive perks made just for Zing members.`}
          />
          <CodeContainer>
            <CodeField id="refCode">{referralCode}</CodeField>
            <CopyButton onClick={() => this.copyCode()} variant="primary">
              Copy
            </CopyButton>
          </CodeContainer>
        </Content>
      </MainPage>
    )
  }
}

ReferPage.defaultProps = {}

ReferPage.propTypes = {}

export default ReferPage
